
import { defineComponent, ref } from "vue";
import HeaderItem from "../src/components/HeaderItem.vue";
import FooterItem from "../src/components/FooterItem.vue";
import SideMenu from "../src/components/SideMenu.vue";
import NavLoader from "../src/views/NavLoader.vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  name: "App",
  components: {
    HeaderItem,
    FooterItem,
    SideMenu,
  },
  setup() {
    const loading = ref(false);
    const router = useRouter();
    const route = useRoute();

    return {
      loading,
    };
  },

  data() {
    return {
      loader: false,
    };
  },

  created() {
    console.log(document.documentElement.clientWidth);
    this.setPageTitle();
  },
  computed: {
    pageTitle() {
      const routeName = this.$route.path;
      let title;
      if (routeName == "/" || routeName == "/login") {
        title = "Вход в личный кабинет";
      } else {
        title = "Личный кабинет";
      }
      return title;
    },
    loginPage() {
      if (this.$route.path == "/login" || this.$route.path == "/") {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    pageTitle: "setPageTitle",
  },
  methods: {
    setPageTitle() {
      document.title = this.pageTitle;
    },
  },
});
